import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {
  private alert = new Subject<AlertsModel>();
  public type: AlertsType = AlertsType.success;
  public dismissionTimeout = 3000;

  public toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  constructor() {
  }

  get(): Observable<AlertsModel> {
    return this.alert.asObservable();
  }
  set(icon: SweetAlertIcon, title: string, content: string = null) {
    this.toast.fire({
      toast: false,
      icon: icon,
      title: title,
      html: content
    });
  }
  toastMsg(icon: SweetAlertIcon, content: string = null) {
    this.toast.fire({
      toast: true,
      icon: icon,
      title: content
    });
  }
  private toContent(content) {
    return content
  }
  saveMsg(content?: string) {
    this.toastMsg('success', '已存檔');
  }
  deleteMsg(content?: string) {
    this.toastMsg('warning', '已刪除');
  }
  copyMsg(content?: string) {
    this.toastMsg('warning', '已複製');
  }
  nullMsg() {
    this.toastMsg('warning', '資料為空');
  }

  confirmForDelete(): Promise<any>{
    return Swal.fire({
      title: '確定要刪除？',
      text: "你可能只是手殘誤觸!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '刪除',
      cancelButtonText: '取消',
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-info ml-2'
      },
      buttonsStyling: false,
    });
  }
  confirmForCopy(): Promise<any>{
    return Swal.fire({
      title: '確定要複製？',
      text: "你可能只是手殘誤觸!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '確定',
      cancelButtonText: '取消',
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-info ml-2'
      },
      buttonsStyling: false,
    });
  }
  confirm(title: string, text: string): Promise<any>{
    return Swal.fire({
      title: title,
      text: text,
      confirmButtonText: '確認',
      customClass: {
        confirmButton: 'btn btn-warning'
      },
      buttonsStyling: false,
    });
  }

  errorMsg(content?: string) {
    this.set('error', 'Warning', (content) ? content : this.toContent('Error'));
  }
  errHttp(err: any, show: boolean = false) {
    let content = (err.error.msg) ? err.error.msg : err.message;
    if (show) {
      console.log(err)
    }
    switch (err.status) {
      case 404:
        this.nullMsg();
        break;
      default:
        this.errorMsg(content);
    }
  }
}
export interface AlertsModel {
  msg: MsgModel;
  type: AlertsType;
  dismissionTimeout: number;
}
export interface MsgModel {
  icon: IconType;
  title: string;
  content: string;
}
export enum IconType {
  info = 'fa fa-info',
  warning = 'fa fa-exclamation',
  copy = 'ft-copy'
}
export enum AlertsType {
  success = 'success',
  info = 'info',
  warning = 'warning',
  danger = 'danger',
  copy = 'amber'
}
